import Accordions4i from "../../common/accordions25.js";
import FilterMenu from "./modules/filtermenu.js";
import SelectedFilters from "./modules/selectedfilters.js";
import RadioButtonFilter from "./modules/radiobuttonfilter.js";
import EventListeners from "./modules/eventlisteners.js";
import SubSearchFilter from "./modules/subsearchfilter.js";
import ColorSelectorFilter from "./modules/colorselectorfilter.js";
import ProductQuantityFilter from "./modules/productquantityfilter.js";
import UpdatePageFromUrl from "./modules/updatepagefromurl.js";

// TODO consider hiding pricemin/pricemax filter area when these two numbers are the same
let betterChoiceAccordions;
const filterAccordions = new Accordions4i();
const betterChoicesTagFilter = document.getElementById("betterChoicesTagFilter");

async function initializeState() {
    const loc = window.location.href;
    const title = document.title;
    const description = document.querySelector('meta[name="description"]').getAttribute('content');
    history.replaceState({ title: title, description: description }, '', loc);

    //polyfill for closest in IE
    if (window.Element && !Element.prototype.closest) {
        Element.prototype.closest = function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i,
                el = this;
            do {
                i = matches.length;
                while (--i >= 0 && matches.item(i) !== el) { };
            } while ((i < 0) && (el = el.parentElement));
            return el;
        };
    }

    if (document.getElementById('PriceRange') !== null) {
        const { default: PriceRangeFilter } = await import('./modules/pricerangefilter.js');
        PriceRangeFilter.init();
    }

    SubSearchFilter.events();
    ProductQuantityFilter.events();
    SelectedFilters.events();
    FilterMenu.events();
    ColorSelectorFilter.events();
    EventListeners.pagerEvent();
    //EventListeners.betterChoicesEvent();
    RadioButtonFilter.events();
    UpdatePageFromUrl.update();
    filterAccordions.init(document.getElementById("mainFilters"));

    const { default: starRating } = await import("../../common/starrating25.js");
    starRating.init();

    //only in us/ca
    if (betterChoicesTagFilter) {
        betterChoiceAccordions = new Accordions4i();
        betterChoiceAccordions.init(betterChoicesTagFilter);
        updateBetterChoiceFilterAccordions();
        window.addEventListener('resize', updateBetterChoiceFilterAccordions);
    }

    if (document.getElementById("pageTips") && document.getElementById("pageTips").querySelector(".accordionHeader")) {
        const tipAccordions = new Accordions4i();
        tipAccordions.init(document.getElementById("pageTips"));
    }

    const { default: LogMetrics } = await import("./modules/logmetrics.js");
    LogMetrics.init();
};

function updateBetterChoiceFilterAccordions() {
    if (window.innerWidth < 600) {
        betterChoiceAccordions.openAll(betterChoicesTagFilter);
    } else {
        betterChoiceAccordions.closeAll(betterChoicesTagFilter);
    }
};

await initializeState();